"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpressionType = void 0;
var ExpressionType;
(function (ExpressionType) {
    ExpressionType["Aggregate"] = "aggregate";
    ExpressionType["Existence"] = "existence";
    ExpressionType["Operator"] = "operator";
    ExpressionType["Term"] = "term";
    ExpressionType["Variable"] = "variable";
})(ExpressionType || (exports.ExpressionType = ExpressionType = {}));
//# sourceMappingURL=ExpressionEvaluator.js.map